module.exports = __webpack_public_path__ + "static/media/то.4ba3de0f.mp3";